import * as React from 'react';
import * as Yup from 'yup';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { DialogStatus } from './DialogStatus';
import { Formik, FormikProps } from 'formik';
import { FormInput } from 'common/components/form/FormInput';

interface SendEmailDialogProps {
  isOpen: boolean;
  email?: string;
  onSubmit: (email: string) => void;
  onCancel: () => void;
  isLoading?: boolean;
  successMessage?: string;
  errorMessage?: string;
  title?: string;
  saveLabel?: string;
}
class SendEmailValues {
  email = '';
}

export class SendEmailDialog extends React.Component<SendEmailDialogProps> {
  validationSchema = Yup.object().shape({
    email: Yup.string()
      .required('Required')
      .email('Must be a valid email'),
  });

  initialValues() {
    return {
      email: this.props.email ? this.props.email : '',
    };
  }

  handleSubmit = (values: SendEmailValues) => {
    this.props.onSubmit(values.email);
  };

  render() {
    const props = this.props;
    return (
      <Modal size="md" isOpen={props.isOpen} toggle={props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          validationSchema={this.validationSchema}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<SendEmailValues>) => (
            <form onSubmit={form.handleSubmit}>
              <ModalHeader toggle={this.props.onCancel}>
                {this.props.title ? this.props.title : 'Send Email'}
              </ModalHeader>
              <ModalBody>
                <FormInput label="Email" name="email" id="email" />
              </ModalBody>
              <ModalFooter>
                <div>
                  {!this.props.successMessage && (
                    <span>
                      <Button color="secondary" onClick={this.props.onCancel}>
                        Cancel
                      </Button>{' '}
                      <Button color="primary" type="submit">
                        {this.props.saveLabel ? this.props.saveLabel : 'Send'}
                      </Button>
                    </span>
                  )}
                  {this.props.successMessage && (
                    <Button color="primary" onClick={this.props.onCancel}>
                      Close
                    </Button>
                  )}
                </div>
              </ModalFooter>
              <DialogStatus
                error={this.props.errorMessage}
                success={this.props.successMessage}
                isLoading={this.props.isLoading}
                loadingMessage="Sending..."
              />
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/dialogs/SendEmailDialog.tsx